import { render, staticRenderFns } from "./npsrating.vue?vue&type=template&id=5218db9e&scoped=true&"
import script from "./npsrating.vue?vue&type=script&lang=js&"
export * from "./npsrating.vue?vue&type=script&lang=js&"
import style0 from "./npsrating.vue?vue&type=style&index=0&id=5218db9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5218db9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5218db9e')) {
      api.createRecord('5218db9e', component.options)
    } else {
      api.reload('5218db9e', component.options)
    }
    module.hot.accept("./npsrating.vue?vue&type=template&id=5218db9e&scoped=true&", function () {
      api.rerender('5218db9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/npsrating.vue"
export default component.exports